import { h, Component } from 'preact';
import { BaseComponent } from "../../common/BaseComponent";
import { IVideoPlayerProps, IVideoPlayerState } from "./IVideoPlayer";
import ReactPlayer from 'react-player';
import { bind } from 'decko';

export class VideoPlayer extends BaseComponent<IVideoPlayerProps, IVideoPlayerState> {

    public refs: { video: ReactPlayer };

    constructor(props, ctx) {
        super(props, ctx);
        this.init(props);
    }

    @bind
    public destroy() {
        if (this.refs.video.player.player.player.destroy)
            this.refs.video.player.player.player.destroy();
        else if (this.refs.video.player.player.player.remove)
            this.refs.video.player.player.player.remove();
    } 

    public init(props) {
        this.setState({
            playing: props.playing,
            url: props.url 
        });
    }

    componentWillReceiveProps(props) {
        this.init(props);
    }

    componentDidMount() {
        window['vp'] = this;
    }

    render() {
        return <ReactPlayer ref={this.setRef("video")} url={this.state.url} playing={this.state.playing} controls width='100%' onError={(e) => { console.log(e); }} />
    }
}


// WEBPACK FOOTER //
// ./components/videoPlayer/videoPlayer.tsx